export enum ThemeOption {
  light = 'light',
  dark = 'dark',
  midnight = 'midnight',
  system = 'system'
}

export type ThemeFamily = 'light' | 'dark';

// Concrete themes map to the CSS family whose token block they render with; midnight
// is a dark-family variant. `system` never reaches themeFamily (it resolves to a
// concrete theme before stamping), so its 'light' entry is only a total-map default.
const THEME_FAMILY: Record<ThemeOption, ThemeFamily> = {
  [ThemeOption.light]: 'light',
  [ThemeOption.dark]: 'dark',
  [ThemeOption.midnight]: 'dark',
  [ThemeOption.system]: 'light'
};

export function themeFamily(option: ThemeOption): ThemeFamily {
  return THEME_FAMILY[option];
}

// Written by the product apps on the shared `sytex.io` domain (the Sytex back's
// `/api/theme/` endpoint is its authority) and read here. This app is the one Sytex
// surface that can only ever READ it: it runs before authentication, so it has no
// session to persist a preference against and no theme picker of its own.
export const THEME_COOKIE_NAME = 'sytex_theme';

// Undefined signals "no known preference" — a browser that has never signed in to a
// product app — which callers must distinguish from an explicit light choice.
export function parseThemeOption(value?: string | null): ThemeOption | undefined {
  const options = Object.values(ThemeOption);
  return options.find(option => option === value);
}

export function resolveThemeOption(value?: string | null): ThemeOption {
  return parseThemeOption(value) ?? ThemeOption.light;
}
